$(document).ready(function() {  

    MAIN_InfluencerAnnouncement();
    MAIN_DeliveryMessage();
    MAIN_ProductDescriptionSlider();
    MAIN_StickyAnnouncement();
    MAIN_ProductAccordion();
    MAIN_RefreshPrice(); //deactivated
    MAIN_ProductScarcity();
    MAIN_ProductTooltip();
    MAIN_OpenChat();
    MAIN_GreetingCard();

    var url = window.location;
    var params = new URLSearchParams(url.search);
    if (params.has('cart')) {
        $('body').trigger('added.ajaxProduct', this.$addToCart);
    }


});
/*****************************************/
/***** INFLUENCER ANNOUNCEMENT ***********/
/*****************************************/
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function showSnackbar(pText) {
    var x = document.getElementById("lm-snackbar");
    x.innerHTML = pText;
    x.className = "show";
    setTimeout(function() {
        x.className = x.className.replace("show", "");
    }, 3000);
}

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
        showSnackbar("Kopiert 👍 Du kannst den Code später an der Kasse einfügen.");
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }

    navigator.clipboard.writeText(text).then(function() {       
        showSnackbar("Kopiert 👍 Du kannst den Code später an der Kasse einfügen.");
    }, function(err) {
        console.error('Async: Could not copy text: ', err);
    });
}

function showCodeInAnnouncement(pInfluencerCode) {  
    var influencerDiscount = "";
    if (pInfluencerCode.includes("10")) {
        influencerDiscount = " 10%";
    } else if (pInfluencerCode.includes("15")) {
        influencerDiscount = " 15%";
    } else if (pInfluencerCode.includes("20")) {
        influencerDiscount = " 20%";
    }
    var discountTitle = "Spare weitere <b>[percentage]</b> mit dem Code <b style='text-transform:uppercase;'>&quot;[code]&quot;</b>";
    discountTitle = discountTitle.replace('[percentage]', influencerDiscount).replace('[code]', pInfluencerCode);
    var discountSubtitle = "⏰ Aktion läuft noch[timer] ⏰";
    discountSubtitle = discountSubtitle.replace("[timer]","<div class='timer--wrapper'><div class='timer-item'><span class='timer Timer_H'>00</span><span class='label'>h</span></div><div class='timer-item'><span class='timer Timer_M'>00</span><span class='label'>min</span></div><div class='timer-item'><span class='timer Timer_S'>00</span><span class='label'>sec</span></div> </div>");
    $('div[data-section-id="header"] > div').first().removeClass('promobar').addClass('announcement-bar').html("<div class='lm-influencer-code'><span style='font-size:16px;'>" + discountTitle + "</span><br>" + discountSubtitle + "</div>");
    $(document).on('click', '.announcement-bar ', function(e) {
        copyTextToClipboard(pInfluencerCode.toUpperCase());        
    });
}

function MAIN_InfluencerAnnouncement() {
    var url = window.location;
    var params = new URLSearchParams(url.search);
    var saleCodeCookie = getCookie('sale_code');
    var saleCodeParam = params.get('sale_code');    
    if (saleCodeParam != undefined) { //if user joins directly with utm params     
            
        setCookie("sale_code", saleCodeParam, 1);
        showCodeInAnnouncement(saleCodeParam);
    } else if (saleCodeCookie != "") { //if user joins second page      
        showCodeInAnnouncement(saleCodeCookie);
    }
}
/*********************************************/
/***** END START INFLUENCER ANNOUNCEMENT *****/
/*********************************************/

/********************************/
/***** PRODUCT TOOLTIP ***********/
/********************************/
function MAIN_ProductTooltip() {
    $(document).on('click', '.lower-third_info', function () {
        var tooltip = $(this).next('.product_tooltip')
        if(tooltip.hasClass('active')) {
            tooltip.removeClass('active').fadeOut();
        } else {
            tooltip.addClass('active').fadeIn();
        }
    });
    $(document).on('click', '.product_tooltip-inner', function () {
        $('.product_tooltip').removeClass('active').fadeOut();
    });
}
/********************************/
/***** DISCOUNT BADGE ***********/
/********************************/
function getPercentage() {
    var discount = getCookie("discount_code"); 
    /*if (!discount || discount ==  '') {
        //discount = getCookie("discount_code");          
        setCookie("discount_code_lm", discount, 1);         
    }   */ 
    if (!discount || discount == '') return 0;
    
    var perc = parseInt(discount.replace(/\D/g, '')) / 100;
    if (isNaN(perc)) return 0;
    $('.cart-subtotal.discount').html('<span>' + (perc * 100) + "% Rabattcode</span><span>" + discount + '</span>').addClass('active');
    var codeString = "Rabattcode &quot;<b>[code]</b>&quot; ist automatisch aktiv";
    codeString = codeString.replace('[code]', discount.toUpperCase());
    $('.lm-discount-note').html(codeString).addClass('active');
    return perc;
}

function MAIN_RefreshPrice() {
    console.log("refresh prices");
    var path = window.location.pathname;
    var perc = getPercentage();
    if (path.includes('/products')) {        
        var oldPrice = parseInt($('.product__price.on-sale').attr('data-regular-price'));          
        var comparePrice = parseInt($('.product__price.product__price--compare').attr('data-regular-price'));
        var newPrice = oldPrice - (oldPrice * perc);            
        var newPriceString = theme.Currency.formatMoney(newPrice, theme.settings.moneyFormat);         
        $('.product__price.on-sale').text(newPriceString);

        var savings = (((comparePrice - (newPrice)) / comparePrice) * 100).toFixed(0);
        var savingsString = "-" + savings + "%";
        $('.lm-price-bar .product__price-savings.lm-percent').text(savingsString);

        //Size guide
        $("div.btn.size-selector").each(function(index) {
            var oldPrice = parseInt($(this).find('.sg-price').attr('data-regular-price'));
            var comparePrice = parseInt($(this).find('.sg-compare').attr('data-regular-price'));
            var newPrice = oldPrice - (oldPrice * perc);
            var newPriceString = theme.Currency.formatMoney(newPrice, theme.settings.moneyFormat); 
            $(this).find('.sg-price').text(newPriceString);
        });

        //Dropdown     
        $(".variant-input-wrap select option").each(function(index) {
            var oldPrice = parseInt($(this).attr('data-regular-price'));           
            var newPrice = oldPrice - (oldPrice * perc);
            var newPriceString = theme.Currency.formatMoney(newPrice, theme.settings.moneyFormat); 
            var size = $(this).text().split('-')[0];
            $(this).text(size + "- " + newPriceString);
        });
        

    } else {       
        $('.grid-product__price').each(function(index) {
            var oldPrice = parseInt($(this).find('.grid-product__price-lm').attr('data-regular-price'));
            var newPrice = oldPrice - (oldPrice * perc);           
            var newPriceString = theme.Currency.formatMoney(newPrice, theme.settings.moneyFormat);
            $(this).find('.grid-product__price-lm').text("ab " + newPriceString);

            var comparePrice = parseInt($(this).find('.grid-product__price--original').attr('data-regular-price'));
            var savings = (((comparePrice - (newPrice)) / comparePrice) * 100).toFixed(0);     
            var savingsString = "-" + savings + "%";
            $(this).find('.lm-percent').text(savingsString);
        });        
    }
    //upsell popup cart
    $('.inner-upsell .prices').each(function(index) {
      var upsellOldPrice = $(this).children('.old-price').attr('data-regular-price');
      var upsellNewPrice = $(this).children('.new-price').attr('data-regular-price');
      var upsellNewestPrice = upsellNewPrice - (upsellNewPrice * perc);
      $(this).children('.new-price').text(theme.Currency.formatMoney(upsellNewestPrice, theme.settings.moneyFormat)).attr('data-price', upsellNewestPrice);
      var savings = (((upsellOldPrice - upsellNewestPrice) / upsellOldPrice) * 100).toFixed(0);
      var savingsString = "-" + savings + "%";
      $(this).children('.compare').text(savingsString);
    });
  
    //cart   
    var itemCountWithoutHanger = 0;
    var totalPrice = 0;

    $('.lm-cart-item[data-product-id!="4736052133970"]').each(function(index) {
        itemCountWithoutHanger += parseInt($(this).attr('data-cart-item-quantity'));
    });
    if (itemCountWithoutHanger >= 2) return; //Return here because of 2er Bundle
    $('.lm-cart-item').each(function(index) {
        var oldPrice = $(this).find('.final-price').attr('data-regular-price');        
        if(oldPrice) {              
          var comparePrice = parseInt($(this).find('.compare').attr('data-regular-price'));  
          var newPrice = oldPrice - (oldPrice * perc);      
          totalPrice += parseFloat(newPrice);
          var newPriceString = theme.Currency.formatMoney(newPrice, theme.settings.moneyFormat);
          $(this).find('.final-price').text(newPriceString);
          
          if(newPrice > 0) {
              var savings = (((comparePrice - newPrice) / comparePrice) * 100).toFixed(0);
              var savingsString = "Du sparst  -" + savings + "%";
              $(this).find('.lm-percent').text(savingsString);
          }
        }      
      

        $(this).find('.product-single__variants option').each(function(index) {
            var regularPrice = parseInt($(this).attr('data-regular-price'));
            var option = $(this).text();            
            var optionParts = option.split('|');
            if(optionParts.length > 1) {             
              var optionSize = optionParts[0].trim();
              var newPrice = regularPrice - (regularPrice * perc);
              newPrice = theme.Currency.formatMoney(newPrice, theme.settings.moneyFormat);
              $(this).text(optionSize + " | " + newPrice);
            }            
        });
      
      //total price       
      var newPriceString = theme.Currency.formatMoney(totalPrice, theme.settings.moneyFormat);     
      $('.cart-subtotal__price').text(newPriceString);
    });     
}
/********************************/
/***** END DISCOUNT BADGE *******/
/********************************/
/******************************/
/***** DELIVERY MESSAGE *******/
/******************************/
function getNthWorkday(pDate, pN) {
    var newN = pN;
    for (var i = 0; i < pN; i++) {
        var date = new Date();
        date.setDate(pDate.getDate() + i + 1);
        if (date.getDay() == 0) {
            newN++;
        }
    }
    return pDate.getDate() + newN;
}

function getDateDayLeadingZero(pDate) {
    var day = pDate.getDate();
    if (day < 10) {
        return '0' + day;
    } else {
        return day;
    }
}

function MAIN_DeliveryMessage() {
    var weekdays = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    var months = ["Jan", "Feb", "Mär", "Apr", "Mai", "Juni", "Juli", "Aug", "Sep", "Okt", "Nov", "Dez"];
    
    var today = new Date();
    var first = new Date();
    var second = new Date();
    first.setDate(getNthWorkday(first, 1));
    second.setDate(getNthWorkday(second, 2));
    var todayText = weekdays[today.getDay()] + ', <br>' + getDateDayLeadingZero(today) + '. ' + months[today.getMonth()];
    var firstText = weekdays[first.getDay()] + ', <br>' + getDateDayLeadingZero(first) + '. ' + months[first.getMonth()];
    var secondText = weekdays[second.getDay()] + ', <br>' + getDateDayLeadingZero(second) + '. ' + months[second.getMonth()];

    //$('.delivery-date').html("<span style='color:black; font-weight:normal;'>&nbsp;ca.&nbsp;</span><b style='color:black;'>" + first.getDate() + '. ' + months[first.getMonth()] + " - " + second.getDate() + '. ' + months[second.getMonth()] + "</b>");

    $('.lm-delivery-tl .t-4').html(todayText);
    $('.lm-delivery-tl .t-5').html(firstText);
    $('.lm-delivery-tl .t-6').html(secondText);
}
/**********************************/
/***** END DELIVERY MESSAGE *******/
/**********************************/
/****************************************/
/***** PRODUCT DESCRIPTION SLIDER *******/
/***************************************/
function MAIN_ProductDescriptionSlider() {
    $('.lm-vertical-reviews').slick({
        vertical: false,
        verticalSwiping: false,
        autoplay: true,
        autoplaySpeed: 2500,
        pauseOnFocus: false,
        pauseOnHover: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: true,
        prevArrow: "<a href='#' class='previos'><i class='fas fa-chevron-left'></i></a>",
        nextArrow: "<a href='#' class='next'><i class='fas fa-chevron-right'></i></a>",
        responsive: [{
            breakpoint: 768,
            settings: {
                vertical: false,
                verticalSwiping: false,
                edgeFriction: 0,
                slidesToShow: 1,
                slidesToScroll: 1,
                /*prevArrow: "<a href='#' class='previos'><i class='fas fa-chevron-up'></i></a>",
                       nextArrow: "<a href='#' class='next'><i class='fas fa-chevron-down'></i></a>",*/
            }
        }]
    });

    $('.lm-image-text.p-slider .image-main.slider').slick({
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 700,
        cssEase: 'ease-in-out',
        fade: true,
        slidesToShow: 1,
        swipe: false,
        slidesToScroll: 1,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
    });
    /*$(document).on('touchstart', '.lm-vertical-reviews', function () {
        $('.lm-vertical-reviews').slick('slickPause');
    });*/
}
/********************************************/
/***** END PRODUCT DESCRIPTION SLIDER *******/
/********************************************/
/*******************************************/
/***** STICKY ANNOUNCEMENT COUNTDOWN *******/
/*******************************************/
function MAIN_StickyAnnouncement() {
    //TODO: Edit header accordingly    

    //if(window.location.pathname.indexOf("/cart") > -1) {
    var stickyBar = false;
    $(window).scroll(function() {
        var windowTop = $(window).scrollTop();
        if (windowTop >= 150) {
            if (!stickyBar) {
                $('header div.announcement-bar.lm-discount').css('display', 'block');
                stickyBar = true;
            }
        } else {
            if (stickyBar) {
                $('header div.announcement-bar.lm-discount').css('display', 'none');
                stickyBar = false;
            }
        }
    });
    //}

    //var countDownDate = new Date('2023-11-25T00:00:00'); 		
    var countDownDate = new Date();
    countDownDate.setHours(24, 0, 0, 0);

    var x = setInterval(function() {
        countdownTick(countDownDate, x);
    }, 1000);
    countdownTick(countDownDate, x);

    function countdownTick(pCountdownDate, pInterval) {
        var now = new Date().getTime();
        var distance = pCountdownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + (days * 24);
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        $('.Timer_HH').text(hours);
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (hours < 10) {
            hours = "0" + hours;
        }
        if (distance <= 0) {
            clearInterval(pInterval);
        } else {
            $('.Timer_S').text(seconds);
            $('.Timer_M').text(minutes);
            $('.Timer_H').text(hours);
        }
    }
}
/***********************************************/
/***** END STICKY ANNOUNCEMENT COUNTDOWN *******/
/***********************************************/
/**********************************/
/***** PRODUCT SCARCITY ***********/
/**********************************/
function MAIN_ProductScarcity() {
    var date = new Date();
    wochentag = new Array("So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa.");
    var months = ["Jan.", "Feb.", "Mär.", "Apr.", "Mai.", "Juni.", "Juli.","Aug.", "Sep.", "Okt.", "Nov.", "Dez."];
    var text = "am " + date.getDate() + ". " + months[date.getMonth()] + " " + date.getFullYear();
    $('.delivery-date').text(text);
}
/**********************************/
/***** END PRODUCT SCARCITY *******/
/**********************************/
/**********************************/
/***** PRODUCT ACCORDION **********/
/**********************************/
function MAIN_ProductAccordion() {
    $('.lm-accordion button.head').click(function() {
        var isActive = $(this).parent().hasClass('active');
        $('.lm-accordion .item.active .body').slideUp(250);
        $('.lm-accordion .item.active').removeClass('active');
        if (!isActive) {
            $(this).next('.body').slideDown(250);
            $(this).parent().addClass('active');
        }
    });
}
/***********************************/
/***** END PRODUCT ACCORDION *******/
/***********************************/
/***********************************/
/***** OPEN CHAT ON MENU CLICK *******/
/***********************************/
function MAIN_OpenChat() {
    $(document).on('click', 'a[href="#chat"]', function(e) {
        $('#fc_frame').css('display', 'block');
        theme.NavDrawer.close()
        window.fcWidget.open({
            replyText: "Hallo Support-Team, ich benötige Hilfe."
        });
    });
}
/**************************************/
/****** GREETING CARD
/**************************************/
function MAIN_GreetingCard() {
    var globalTimeout = null;
    createGreetingCard();

    if (document.location.toString().includes('?greetingcard')) {
        openGreetingCard();
    }
    $(document).on('click', '.lm-cart-item.add-canvas', function() {
        openGreetingCard();
    });
    $(document).on('click', '.lm-greetingcard .save', function() {
        var _this = this;
        $(_this).addClass('btn--loading');
        var productHandle = $('.lm-greetingcard').attr('data-product-handle');
        var params = {};
        var values = {
          "motiv": $('.lm-greetingcard .variant-selection span.active').attr('data-key').toLowerCase(),
          "text": $('.lm-greetingcard textarea').val()
        };
        var variantID = $('.lm-greetingcard .variant-selection span.active').attr('data-variant-id');
        params['Text'] = $('.lm-greetingcard textarea').val();
        params['_lm-customizer0'] = "https://backend.leinwandmomente.de/de/display/8540628058376?type=card1&" + new URLSearchParams(values).toString();
        params['_preview-url'] = "https://backend.leinwandmomente.de/de/display/8540628058376?type=[type]&" + new URLSearchParams(values).toString();
        params['_edit-url'] = window.location.origin + '/products/' + productHandle + "?variant=" +  variantID + "&lm&" + new URLSearchParams(values).toString();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: [{
                    id: variantID,
                    properties: params,
                    quantity: 1,
                }],
            },
            dataType: 'json',
            success: function(data) {
                closeGreetingCard();
                $(_this).removeClass('btn--loading');
                clearGreetingCard();
                $('body').trigger('added.ajaxProduct', false);
            },
            error: function(data) {
                $(_this).removeClass('btn--loading');
                console.log(data);
            },
        });
    });
    $(document).on('click', '.lm-greetingcard .discard, .lm-greetingcard .exit', function() {
        closeGreetingCard();
        clearGreetingCard();
    });
    $(document).on('click', '.lm-greetingcard .variant-selection span', function() {
        $('.lm-greetingcard .variant-selection span').removeClass('active');
        $(this).addClass('active');
        createGreetingCard();
    });
    $(document).on('input', '.lm-greetingcard textarea', function() {     
        if ($(this).val() != "") {
            $(this).addClass('filled');
            $('.lm-greetingcard .row-count').removeClass('hide');
        } else {
            $(this).removeClass('filled');
            $('.lm-greetingcard .row-count').addClass('hide');
        }
        if (globalTimeout != null) {
            clearTimeout(globalTimeout);
        }
        globalTimeout = setTimeout(function() {
            globalTimeout = null;
            createGreetingCard();
        }, 250);
    });

    function openGreetingCard() {
        $('.lm-greetingcard').fadeIn(0);
        $('body').addClass('lm-fixed');
    }
    function closeGreetingCard() {
        $('.lm-greetingcard').fadeOut(0);
        $('body').removeClass('lm-fixed');
    }
    function clearGreetingCard() {
        $('.lm-greetingcard .variant-selection span.active').removeClass('active');
        $('.lm-greetingcard .variant-selection span').first().addClass('active');
        $('.lm-greetingcard .message textarea').val('').removeClass('filled');
        createGreetingCard();
    }

    function createGreetingCard() {
        var values = {
          "motiv": $('.lm-greetingcard .variant-selection span.active').attr('data-key').toLowerCase(),
          "text": $('.lm-greetingcard textarea').val()
        };        
        var url = "https://backend.leinwandmomente.de/de/display/8540628058376?type=card1&" + new URLSearchParams(values).toString();
        $('.lm-greetingcard img').attr('src', url);
        var image = new Image();
        image.src = url;
        if (!image.complete) {
            $('.lm-greetingcard div.lm-loader').fadeIn(50);
        }

        image.onload = function() {
            $('.lm-greetingcard div.lm-loader').fadeOut(50);
        };
    }

    function countLineBreaks(string, lengthFromStart) {
        var left = string.substr(0, lengthFromStart);
        var countOfLinebreaks = (left.split("\n")).length;
        return countOfLinebreaks;
    }

    function handlePaste() {
        onPaste = true;
    }
    var textOutput = "";
    var onPaste = false;
    $(document).on('input', '.lm-greetingcard textarea', function() {
        var charactersPerLine = $(this).attr('cols');
        var maxLines = $(this).attr('rows');
        var textInput = $(this)[0].value;
        var inputAsRows = textInput.split("\n");
        var inputAsOneLine = textInput.replace(/(\r\n\t|\n|\r\t)/gm, "");
        var cursorPositionOnInput = $(this)[0].selectionStart;
        var cursorOffsetAfterOutput = 0;
        var visibleCharactersPerLine = Math.floor(($(this)[0].offsetWidth) / 9);
        var additionalTextAreaRows = 0;
        var totalRows = inputAsRows.length;
        var row;
        var lineBreakCount = 0;
        var characterCount = 0;
        for (row = 0; row < totalRows; ++row) {
            if (inputAsRows[row].length > charactersPerLine) {
                if (inputAsRows[row + 1] === undefined) {
                    inputAsRows[row + 1] = "";
                    totalRows++;
                }
                var lastWhiteSpace = inputAsRows[row].lastIndexOf(" ");
                if(lastWhiteSpace > -1) {                  
                  inputAsRows[row + 1] = inputAsRows[row].substring(lastWhiteSpace + 1) + inputAsRows[row + 1];
                  inputAsRows[row] = inputAsRows[row].substring(0, lastWhiteSpace + 1);
                  cursorOffsetAfterOutput = 1;
                  var newOutput = inputAsRows.join("\n");
                  if (newOutput.substr(cursorPositionOnInput - 1, 1) == "\n") {                    
                      cursorOffsetAfterOutput = 1;
                  }
                } else {
                   inputAsRows[row + 1] = inputAsRows[row].substring(charactersPerLine-1) + inputAsRows[row + 1];
                   inputAsRows[row] = inputAsRows[row].substring(0, charactersPerLine-1) + "-";
                   cursorOffsetAfterOutput = 2;
                }
                
                
            }
            if (inputAsRows[row].length > visibleCharactersPerLine) {
                additionalTextAreaRows = additionalTextAreaRows + Math.floor(inputAsRows[row].length / visibleCharactersPerLine);
            }
        }
        if (inputAsRows.length <= maxLines && inputAsOneLine.length <= (maxLines * charactersPerLine)) {
            textOutput = inputAsRows.join("\n");
            if (onPaste) {
                cursorOffsetAfterOutput = cursorOffsetOnPaste(textInput, cursorPositionOnInput, totalRows)
            }
        } else {
            cursorOffsetAfterOutput = -1;
        }
        $(this)[0].value = textOutput;
        $(this)[0].selectionStart = cursorPositionOnInput + cursorOffsetAfterOutput;
        $(this)[0].selectionEnd = cursorPositionOnInput + cursorOffsetAfterOutput;
        onPaste = false;

        var pattern = $('.lm-greetingcard .row-count').attr('data-pattern');
        var rowCount = inputAsRows.length;
        if(rowCount > maxLines) {
          rowCount = maxLines;
        }
        $('.lm-greetingcard .row-count').text(pattern.replace('[row]', rowCount));
      
    });

}
/**************************************/
/****** OTHER
/**************************************/
$(document).on('click', '.Inline_Upsell_Button', function() {
    var _this = this;
    if ($('.Inline_Upsell_Button').text() != "Hinzufügen") {
        return;
    }

    $(_this).addClass('btn--loading');
    var cartItems = [{
        id: "32764891955282",
        quantity: 1,
    }];


    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            items: cartItems,
        },
        dataType: 'json',
        success: function(data) {
            $(_this).removeClass('btn--loading');
            $('.Inline_Upsell_Button').text("Gute Wahl ✅");
            $('.Inline_Upsell_Button').addClass('deactivated');
            $('body').trigger('added.ajaxProduct', false);
        },
        error: function(data) {
            $(_this).removeClass('btn--loading');
            console.log(data);
        },
    });
});

/**************************************/
/****** EVENT LOG
/**************************************/
var id = Math.floor(Math.random() * 100000);
$(document).on('click', '.lm-go-checkout', function(e) {
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=go_to_checkout_' + id.toString());
});
$(document).on('click', '.hide-btn', function () {     
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=hide_preview_' + id.toString());
});
$(document).on('click', '.lm-live-preview', function () {    
    var t = $('.lm-live-preview span').text();
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=' + t + '_' + id.toString());
});
$(document).on('click', '.lm-countdown', function () {    
    var t = $('.lm-countdown .text').text();
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=' + t + '_' + id.toString());
});
$(document).on('click', '#lm-product-sticky-atc', function () { 
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=sticky_personalize');
});
$('.lm-personalize').on('click', function () { 
    var t = $('.variant-input-wrap select').val();
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=add_to_cart_' + t);
});
$(document).on('click', '.btn.size-selector ', function () { 
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=size_selected');
});
$(document).on('click', '#lm-multi-upsell .content ul.products li:not(.active)', function () { 
    var t = $(this).attr('data-product-sku');
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=multi_upsell_' + t);
});
$(document).on('click', '#lm-multi-upsell .content ul.products li.active', function () { 
    var t = $(this).attr('data-product-sku');
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=deactivate_multi_upsell_' + t);
});
$(document).on('click', '#lm-multi-upsell .lm-multi-upsell-close', function () {     
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=close_multi_upsell');
});
$(document).on('click', '#lm-multi-upsell #lm-upsell-add', function () {     
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=continue_multi_upsell');
});
$(document).on('click', '.add-canvas', function () {     
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=upsell_greeting_card');
});
$(document).on('click', '.lm-discount.announcement-bar', function () {     
    $.get('https://leinwandmomente.deseyve.com/personalize.php?type=announcement_clicked');
});